<template>
	<button class="btn" :class="classes" @click="buttonClicked" :disabled="isDisabled || isLoading">
		<div class="btn-animation" v-if="isLoading">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
		<template>
			<span class="mdl-m--hidden">{{ T(text) }}</span>
			<span class="mdl-m--shown">{{ T(mobileText || text) }}</span>
		</template>
	</button>
</template>

<script>
	import defaultMixin from "../../mixins/default";

	export default {
		name: "d21-button",
		mixins: [defaultMixin],
		props: {
			isPrimary: {
				type: Boolean,
				default: false
			},
			isLoading: {
				type: Boolean,
				default: false
			},
			isDisabled: {
				type: Boolean,
				default: false
			},
			text: {
				type: String,
				required: true
			},
			mobileText: {
				type: String,
				default: ""
			}
		},
		computed: {
			classes() {
				const classes = [];
				if (this.isPrimary) classes.push("btn-primary");
				else classes.push("btn-black-outline");
				if (this.isLoading) classes.push("btn-transparent");
				return classes;
			}
		},
		methods: {
			buttonClicked(evt) {
				this.$emit("click", evt);
			}
		},
	}
</script>